
export const awsConfig = {
    cognito: {
        userPoolId: 'eu-central-1_QGAxqXeTU', 
        userPoolClientId: '5chll45j25779ed1abmbu0c4e9', 
        region: 'eu-central-1' 
    },
    api: {
        // invokeUrl: 'https://4lisgdhuna.execute-api.eu-central-1.amazonaws.com/prod/',
        // invokeUrl: 'https://gft5tugdsc.execute-api.eu-central-1.amazonaws.com/test/'
        invokeUrl: `${process.env.REACT_APP_API_URL}`
    }
};
